import {NgModule} from '@angular/core';
import {OauthCheckrComponent} from './oauth-checkr.component';

@NgModule({
    declarations: [OauthCheckrComponent]
})
export class OauthCheckrModule {}
